import { connect } from 'react-redux'
import authSelector from 'modules/Auth/selectors'
import ManageProfile from 'modules/ManageProfile/index'
import {
  getUserRoles,
  getUserInfo,
  getListOfCountries,
} from 'modules/Auth/actions'

import {
  changePassword,
  updateNotification,
  SendOtp,
  checkOtp,
  updateUserData,
  setUserData,
} from 'modules/ManageProfile/actions'
const mapStateToProps = state => ({
  userData: authSelector.getUserData(state),
  userRole: authSelector?.getUserRoleList(state),
  userId: authSelector?.getUserId(state),
  listOfCountries: authSelector.getListOfCountries(state),
})

const mapDispatchToProps = {
  getUserRoles,
  changePassword,
  updateNotification,
  SendOtp,
  checkOtp,
  updateUserData,
  setUserData,
  getUserInfo,
  getListOfCountries,
}

export default connect(mapStateToProps, mapDispatchToProps)(ManageProfile)
